import { data } from './hardcoded';
import { renderTooltip } from '../../../../helpers/Tooltip';
import { useLinearGradientAreaChart } from 'datastake-daf/dist/hooks'
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useResizeContext } from 'datastake-daf/dist/context';
import moment from 'moment';

export const getFill = (data = []) => {
  const split = (100 / data.length) + 0.75;
  const COLORS = {
    ORANGE: 'orange',
    GREEN: 'green',
    RED: 'red',
  }

  let _split = 0;
  let fill = `linear-gradient(0deg, `
  let lastColor = COLORS.ORANGE;

  data.forEach((d, i) => {
    const _next = data[i + 1];
    const diff = (_next?.Score || 0) - d.Score;
    let changedColor = lastColor;

    if (diff === 0 && lastColor !== COLORS.ORANGE) {
      changedColor = COLORS.RED;
    }

    if (diff > 0) {
      changedColor = COLORS.GREEN;
    }

    if (changedColor !== lastColor) {
      fill += `${lastColor} ${_split}%`;

      fill += ', ';

      fill += `${changedColor} ${_split}%`;

      _split += split;
      lastColor = changedColor;

      fill += ', ';
    } else {
      _split += split;
    }
  });

  fill += `${lastColor} 100%)`;

  fill = fill.replace('red', '#FDA29B')
  fill = fill.replace('green', '#6AD99E')
  fill = fill.replace('orange', '#FFC069')
  return fill;
}

export default function useMonthlyProgress({ container }) {
  const { t } = useTranslation();
  const { isCollapsed } = useResizeContext();

  const _renderTooltip = useCallback((title, items) => {
    return renderTooltip({
      title: moment((title || '').split('M')[1], 'M').format('MMMM'),
      items: [
        {
          label: t('Payment break activated'),
          value: `${items[0].value}$`,
        }
      ]
    })
  }, [t]);

  useLinearGradientAreaChart({
    data: data,
    container,
    fill: getFill(data),
    renderTooltip: _renderTooltip,
    updateTrigger: isCollapsed,
  });
}
